import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { getAll as getAllTiers } from '@/api/tiers/index';
import { getAll as getAllProduits } from '@/api/produit/index';
import { getAll as getAllSupportCommerciaux } from '@/api/supportCommercial';
import i18n from '@/i18n/index';
import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { TIERS_TYPE_CLIENT, TIERS_TYPE_FOURNISSEUR } from '@/configuration/tiers/tiersConf';
import { create as createCommande, echeancierGenerationAll } from '@/api/commande';
import { create as createProduitFace } from '@/api/produit/produitFace';
import moment from 'moment';
import formatDate from '@/services/general/formatIsoDate';
import { genererCommande } from './genererCommande';
import { genererEcheancierCommandeDtos } from './genererEcheancier';
import {
  validationCommande,
  validationCommandeGeneree,
  validationCreationProduit,
  validationIntervenants,
  validationLigneCommande,
  validationEcheancier,
} from './validations';
import generationProduits from './genererProduitFace';
import {
  isNoPropertie,
  getSuffixedTypes,
  generateRef,
  typeLignes,
  findConfrere,
} from './services';

export function ErrorCommandeGeneraleTranslate(errors) {
  if (!errors || !Array.isArray(errors)) return [];
  return errors.map(error => {
    if (error.endsWith('_NOT_FOUND')) {
      if (error.includes('_PRODUIT_')) {
        return i18n.t('importationCommandeGenerale.errors.notFoundPropertie', { label: `produit ${error.split('_')[3]}` });
      }
      if (error.includes('PRODUIT_')) {
        return i18n.t('importationCommandeGenerale.errors.notFoundPropertie', { label: error.split('_')[1] });
      }
      if (typeLignes.includes(error.split('_')[3])) {
        return i18n.t('importationCommandeGenerale.errors.notFoundPropertie', { label: `${error.split('_')[4]}` });
      }
      if (error.includes('COMMERCIAL_')) {
        return i18n.t('importationCommandeGenerale.errors.notFoundPropertie', { label: i18n.t('importationCommandeGenerale.commercial') });
      }
      if (error.includes('ASSISTANT_')) {
        return i18n.t('importationCommandeGenerale.errors.notFoundPropertie', { label: i18n.t('importationCommandeGenerale.assistant') });
      }
      if (error.includes('AGENCE_')) {
        return i18n.t('importationCommandeGenerale.errors.notFoundPropertie', { label: i18n.t('importationCommandeGenerale.agence') });
      }
      if (error.includes('INTERVENANT_')) {
        return i18n.t('importationCommandeGenerale.errors.notFoundPropertie', { label: i18n.t('importationCommandeGenerale.intervenant') });
      }
      if (error.includes('ROLE_')) {
        return i18n.t('importationCommandeGenerale.errors.notFoundPropertie', { label: i18n.t('importationCommandeGenerale.role') });
      }
    }
    if (error.endsWith('_IS_REQUIRED')) {
      if (error.includes('LIGNE_COMMANDE_')) {
        if (typeLignes.includes(error.split('_')[3])) {
          return i18n.t('importationCommandeGenerale.errors.requiredPropertie', { label: error.split('_')[4] });
        }
        return i18n.t('importationCommandeGenerale.errors.requiredPropertie', { label: error.split('_')[3] });
      }
      if (error.includes('ECHEANCIER_')) {
        return i18n.t('importationCommandeGenerale.errors.requiredPropertie', { label: error.split('_')[2] });
      }
      return i18n.t('importationCommandeGenerale.errors.requiredPropertie', { label: error.split('_')[0] });
    }
    if (error.includes('_MAX_LENGTH_')) {
      if (error.includes('LIGNE_COMMANDE_')) {
        return i18n.t('importationCommandeGenerale.errors.maxLengthPropertie', { label: `${error.split('_')[3]} sur la ligne commande n°${error.split('_')[2]}`, length: error.split('_')[error.split('_').length - 1] });
      }
      return i18n.t('importationCommandeGenerale.errors.maxLengthPropertie', { label: error.split('_')[0], length: error.split('_')[error.split('_').length - 1] });
    }

    if (error.includes('_BASIC_CALCUL_NOT_CORRECT')) {
      if (typeLignes.includes(error.split('_')[3])) {
        return i18n.t('importationCommandeGenerale.errors.basicCalcul', { type: error.split('_')[3], ligne: error.split('_')[2] });
      }
    }
    if (error.includes('_BASIC_CALCUL_INFORMATIONS_NOT_CORRECT')) {
      if (typeLignes.includes(error.split('_')[3])) {
        return i18n.t('importationCommandeGenerale.errors.basicCalculInformations', { type: error.split('_')[3], ligne: error.split('_')[2] });
      }
    }
    if (error.includes('_NET_CALCUL_NOT_CORRECT')) {
      if (typeLignes.includes(error.split('_')[3])) {
        return i18n.t('importationCommandeGenerale.errors.netCalcul', { type: error.split('_')[3], ligne: error.split('_')[2] });
      }
    }
    if (error.includes('_NET_CALCUL_INFORMATIONS_NOT_CORRECT')) {
      if (typeLignes.includes(error.split('_')[3])) {
        return i18n.t('importationCommandeGenerale.errors.netCalculInformations', { type: error.split('_')[3], ligne: error.split('_')[2] });
      }
    }

    if (error.includes('_SMALLER_THAN_FIRST_ECHEANCE')) {
      if (typeLignes.includes(error.split('_')[4])) {
        return i18n.t('importationCommandeGenerale.errors.montantSmaller', { type: error.split('_')[4], ligne: error.split('_')[1] });
      }
    }

    switch (error) {
      case 'COMMANDE_HAS_NO_LIGNES':
        return i18n.t('importationCommandeGenerale.errors.hasNoLignes');
      case 'COMMANDE_HAS_NO_INTERVENANTS':
        return i18n.t('importationCommandeGenerale.errors.hasNoIntervenants');
      case 'COMMANDE_INTERVENANTS_DOUBLE':
        return i18n.t('importationCommandeGenerale.errors.intervenantDouble');
      case 'INTERVENANT_TOO_MUCH_FOR_ROLE':
        return i18n.t('importationCommandeGenerale.errors.tooMuchIntervenants');
      case 'MONTANT_ERROR':
        return i18n.t('importationCommandeGenerale.errors.montantError');
      case 'SUM_QUOTE_PART_NOT_CORRECT':
        return i18n.t('importationCommandeGenerale.errors.sumQuotePart');
      case 'TOTAL_TTC_NOT_CORRECT':
        return i18n.t('importationCommandeGenerale.errors.totalTtc');
      case 'RECONDUCTION_WITH_OUT_RENOUVELABLE':
        return i18n.t('importationCommandeGenerale.errors.reconductionWithOutRenouvelable');
      case 'NO_DATE_PREAVIS_IF_NO_RENOUVELABLE':
        return i18n.t('importationCommandeGenerale.errors.datePreavisSansRenouvelable');
      case 'NO_DATE_RENOUVELLEMENT_IF_NO_RENOUVELABLE':
        return i18n.t('importationCommandeGenerale.errors.dateRenouvellementSansRenouvelable');
      default:
        return error;
    }
  }).join(' - ');
}

function getDistinctList(array, targets, emptyField = []) {
  const items = [];
  for (let i = 0; i < array.length; i += 1) {
    for (let j = 0; j < targets.length; j += 1) {
      const value = array[i][targets[j]];
      const allFieldEmpty = emptyField.length === 0
      || emptyField.every(field => isNoPropertie(array[i][field]));
      if (!isNoPropertie(value) && allFieldEmpty) items.push(value);
    }
  }
  return [...new Set(items)];
}

function getFilteredLignesWithOutProduit(lignes) {
  return lignes.filter(lg => isNoPropertie(lg.produit) && !isNoPropertie(lg.ville));
}

function decoreConfrere(lignesCommandes, fournisseurs) {
  for (let i = 0; i < lignesCommandes.length; i += 1) {
    const produit = lignesCommandes[i];
    const confrere = findConfrere(fournisseurs, produit.confrere);
    if (confrere) {
      produit.confrereRef = generateRef(confrere.nomCommercial);
    }
  }
}

async function getAllSequenceMax(references, societeId) {
  const promises = [];

  references.forEach(ref => {
    promises.push(getAllProduits({
      query: {
        actif: true,
        referenceMasque: `^${ref}\\d{6}$`,
        societeId: societeId,
      },
      ascending: 0,
      orderBy: 'reference',
      limit: 1,
    }));
  });

  const referencesMax = (await Promise.all(promises))
    ?.map(res => res.data?.result?.items[0]?.reference);

  const dictRef = references.reduce((a, v, index) => {
    const ref = referencesMax[index];
    if (!ref) return a;
    const sequence = Number(referencesMax[index].replace(v, '') ?? 0);
    a[v] = sequence;
    return a;
  }, {});

  return dictRef;
}

function compressedEcheancier(echeanciers) {
  const datesDebut = echeanciers.map(e => moment(e.dateDebut));
  datesDebut.sort((a, b) => a.isAfter(b));

  const datesFin = echeanciers.map(e => moment(e.dateFin));
  datesFin.sort((a, b) => a.isBefore(b));

  return {
    dateDebut: formatDate(datesDebut[0].toDate()),
    dateFin: formatDate(datesFin[0].toDate()),
    echeancierLignes: echeanciers.map(e => e.echeancierLignes).flat(3),
    quantitePeriodicite: echeanciers[0].quantitePeriodicite,
    referenceEcheancier: echeanciers[0].referenceEcheancier,
    unitePeriodicite: echeanciers[0].unitePeriodicite,
  };
}

function gestionEcheancier(commandes, echeanciers) {
  for (let i = 0; i < commandes.length; i += 1) {
    const commande = commandes[i];
    const references = commande.lignesCommande
      .map(ligne => {
        if (ligne.lignesCommande) {
          return ligne.lignesCommande
            .filter(l => !!l.referenceEcheancier)
            .map(ln => ln.referenceEcheancier);
        }
        return ligne.referenceEcheancier;
      })
      .flat(3);
    if (references.filter(Boolean).length !== 0) {
      references.forEach(ref => {
        const echs = echeanciers.filter(e => e.referenceEcheancier === ref);
        if (echs.length > 0) {
          commande.echeanciers.push(
            compressedEcheancier(echs),
          );
        }
      });
    }
  }
}

async function allTiersFromFile(fileIntervenants, fileLignesCommandes, societeId) {
  const intervenantCodes = getDistinctList(fileIntervenants, ['codeTiers']);
  const intervenantReferences = getDistinctList(fileIntervenants, ['referenceExterne'], ['codeTiers']);
  const intervenantNomsCommerciaux = getDistinctList(fileIntervenants, ['nomCommercial'], ['referenceExterne', 'codeTiers']);
  const fournisseurNomsCommerciaux = getDistinctList(fileLignesCommandes, ['confrere', ...getSuffixedTypes('fournisseur')]);

  const promises = [];
  if (intervenantCodes.length > 0) {
    promises.push(getAllTiers({
      query: {
        societeId: societeId,
        codes: intervenantCodes,
        type: TIERS_TYPE_CLIENT,
      },
      limit: NO_PAGINATION,
    }));
  } else {
    promises.push(Promise.resolve([]));
  }
  if (intervenantReferences.length > 0) {
    promises.push(getAllTiers({
      query: {
        societeId: societeId,
        referencesExterne: intervenantReferences,
        type: TIERS_TYPE_CLIENT,
      },
      limit: NO_PAGINATION,
    }));
  } else {
    promises.push(Promise.resolve([]));
  }
  if (intervenantNomsCommerciaux.length > 0 || fournisseurNomsCommerciaux.length > 0) {
    promises.push(getAllTiers({
      query: {
        societeId: societeId,
        nomsCommerciaux: [...intervenantNomsCommerciaux, ...fournisseurNomsCommerciaux],
      },
      limit: NO_PAGINATION,
    }));
  } else {
    promises.push(Promise.resolve([]));
  }

  const [resCodes, resReference, resNoms] = await Promise.all(promises);
  const tiersCodes = resCodes?.data?.result?.items ?? [];
  const tiersReferences = resReference?.data?.result?.items ?? [];
  const tiersNoms = resNoms?.data?.result?.items ?? [];

  const tiers = [...tiersCodes, ...tiersReferences, ...tiersNoms];
  return tiers.filter((t, index) => tiers.findIndex(ti => ti.id === t.id) === index);
}

export async function makeCommandeGeneraleGenerated(file) {
  const fileCommandes = file[0];
  const fileIntervenants = file[1];
  const fileLignesCommandes = file[2];

  // Retirer les labels
  fileCommandes.shift();
  fileIntervenants.shift();
  fileLignesCommandes.shift();

  // ajouter la recherche par referenceExterne + NomCommercial
  const produitReferences = getDistinctList(fileLignesCommandes, ['produit', ...getSuffixedTypes('referenceProduit')]);

  const societeId = store.getters['societe/societeActiveId'];
  await Promise.all([
    store.dispatch('parametres/loadParametreUtilisateurForce', PARAMETRES_KEYS.utilisateur),
    store.dispatch('parametres/loadParametreForce', PARAMETRES_KEYS.faceMotifNonCom),
  ]);

  const promises = [];
  promises.push(allTiersFromFile(fileIntervenants, fileLignesCommandes, societeId));
  if (produitReferences.length > 0) {
    promises.push(getAllProduits({
      query: {
        actif: true,
        references: [...new Set(produitReferences)],
        societeId: societeId,
      },
      limit: NO_PAGINATION,
    }));
  } else {
    promises.push(Promise.resolve([]));
  }
  promises.push(getAllSupportCommerciaux({
    query: {
      societeId: societeId,
    },
    limit: NO_PAGINATION,
  }));
  const [tiers, responseProduits, responseSupports] = await Promise.all(promises);

  const societe = store.getters['societe/societeActive'];
  const users = store.getters['parametres/parametre'](PARAMETRES_KEYS.utilisateur);
  const motifs = store.getters['parametres/parametre'](PARAMETRES_KEYS.faceMotifNonCom);
  const clients = tiers.filter(i => i.type === TIERS_TYPE_CLIENT);
  const fournisseurs = tiers.filter(i => i.type === TIERS_TYPE_FOURNISSEUR);
  let produits = responseProduits?.data?.result?.items ?? [];
  const supportsCommerciaux = responseSupports?.data?.result?.items ?? [];

  // Gestion des sequences max pour chaque confreres
  decoreConfrere(fileLignesCommandes, fournisseurs);
  const confrereCodes = getDistinctList(fileLignesCommandes, ['confrereRef'], ['produit']);

  const referencesMax = await getAllSequenceMax(
    [generateRef(societe.libelle), ...confrereCodes],
  );

  const errors = [];
  const commandes = [];
  let produitsToCreate = [];
  let allEcheancierToCreate = [];
  for (let i = 0; i < fileCommandes.length; i += 1) {
    try {
      let errorsValid = [];
      const intervenants = fileIntervenants.filter(l => l.codeCommande === fileCommandes[i].code);
      const lignes = fileLignesCommandes.filter(l => l.codeCommande === fileCommandes[i].code);

      errorsValid = errorsValid.concat(validationCommande(fileCommandes[i], societe, users));

      // Génération des produits
      errorsValid = errorsValid.concat(validationCreationProduit(
        lignes, produits, fournisseurs, motifs,
      ));
      const lignesWithProduitToCreate = getFilteredLignesWithOutProduit(lignes);
      const newProduits = generationProduits(
        lignesWithProduitToCreate,
        fileCommandes[i],
        societe,
        supportsCommerciaux,
        fournisseurs,
        motifs,
        referencesMax,
        produits,
      );
      produits = produits.concat(newProduits);
      produitsToCreate = produitsToCreate.concat(newProduits);

      errorsValid = errorsValid.concat(validationIntervenants(
        intervenants, clients, fileCommandes[i],
      ));

      errorsValid = errorsValid.concat(validationLigneCommande(
        lignes, produits, fournisseurs, motifs,
      ));

      if (errorsValid.length > 0) throw errorsValid;

      // Génération de commandes
      const commandeToCreate = genererCommande(
        fileCommandes[i], intervenants, lignes, clients, produits, fournisseurs,
      );

      errorsValid = errorsValid.concat(validationCommandeGeneree(commandeToCreate));

      // Gestion des echéanciers
      errorsValid = errorsValid.concat(validationEcheancier(fileCommandes[i], lignes));

      allEcheancierToCreate = allEcheancierToCreate.concat(
        genererEcheancierCommandeDtos(commandeToCreate, fileCommandes[i]),
      );

      if (errorsValid.length > 0) throw errorsValid;
      commandes.push(commandeToCreate);
    } catch (e) {
      errors.push({ numLigne: fileCommandes[i].numLigne, errors: e });
    }
  }

  if (errors.length > 0) {
    errors.unshift({ total: fileCommandes.length, totalErrors: errors.length });
    throw errors;
  }

  // Gestion echeancier dans commandes
  const generatedEcheancier = (await echeancierGenerationAll(allEcheancierToCreate))?.data?.result;
  gestionEcheancier(commandes, generatedEcheancier);
  return [commandes, produitsToCreate];
}

function changeProduitFaceId(commande, dict) {
  commande.lignesCommande.forEach(ligne => {
    const createdProduct = dict[ligne.produitId];
    if (createdProduct) {
      ligne.produitId = createdProduct.id;
      ligne.libelle = createdProduct.libelle;
    }
  });
}

export async function makeCommandeGeneraleImport(itemToCreate) {
  const commandes = itemToCreate[0];
  const produits = itemToCreate[1];
  const errors = [];
  const dictToMatchProduitIds = {};

  for (let i = 0; i < produits.length; i += 1) {
    try {
      // eslint-disable-next-line no-await-in-loop
      const createdProduit = (await createProduitFace(produits[i])).data.result;

      // Tracabilite des produits créer
      dictToMatchProduitIds[produits[i].id] = {
        id: createdProduit.id,
        libelle: createdProduit.libelle,
      };
    } catch (e) {
      errors.push({ commande: produits[i], error: e });
    }
  }

  for (let i = 0; i < commandes.length; i += 1) {
    try {
      const commandeToCreate = commandes[i];
      changeProduitFaceId(commandeToCreate, dictToMatchProduitIds);
      // eslint-disable-next-line no-await-in-loop
      await createCommande(commandeToCreate);
    } catch (e) {
      errors.push({ commande: commandes[i], error: e });
    }
  }
  if (errors.length > 0) throw errors;
}
